import CustomTag from 'components/Buttons/Tag/CustomTag'
import React from 'react'
import { Topup } from 'types'
import style from 'assets/css/View.module.css'
import axiosClient from 'axios-client'

interface TopupViewProps {
  topup?: Topup
}

const TopupView: React.FC<TopupViewProps> = (props: TopupViewProps) => {
  const { topup } = props

  if (!topup) return <>No topup selected</>

  const onCancel = () => {
    axiosClient.post('/topups/'+ topup.id+'/cancel')
    .then(()=>{
        topup.status = 'canceled'
    })
  }

  const onConfirm = () => {
    axiosClient.post('/topups/'+ topup.id+'/confirm')
    .then(()=>{
        topup.status = 'confirmed'
    })
  }

  const onWire = () => {
    axiosClient.post('/topups/'+ topup.id+'/wire')
    .then(()=>{
        topup.status = 'wired'
    })
  }

  return (
    <>
      <div className={`${style.data}`}>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Reference</div>
          <div className={`${style.info}`}>{topup.reference}</div>
        </div>

        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Amount</div>
          <div className={`${style.info}`}>{topup.amount}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Bank fee</div>
          <div className={`${style.info}`}>{topup.bankFee}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Commission :</div>
          <div className={`${style.info}`}>{topup.commission}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Date</div>
          <div className={`${style.info}`}>{topup.date}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>type</div>
          <div className={`${style.info}`}>{topup.type}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>topup</div>
          <div className={`${style.info}`}>{topup.proof}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Client</div>
          <div className={`${style.info}`}>{topup.client.name}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Status</div>
          <CustomTag>{topup.status}</CustomTag>
        </div>
      </div>

      {topup.status === 'pending' && 
      <>
      <button onClick={onCancel}>Cancel</button>
      <button onClick={onConfirm}>Confirm</button>
      </>
      }

{(topup.status === 'confirmed' && topup.account) && 
      <>
      <button onClick={onWire}>wired</button>
      </>
      }
    </>
  )
}

export default TopupView
